import Decimal from "break_infinity.js";
import { firestore } from "../firebase";
import { Game } from "../types/game";

const db = firestore;

export const saveGameInCloud = async (uid: string, gameData: any) => {
  const userRef = db.collection("users").doc(uid);

  console.log("Saving game in Cloud:", gameData);
  await userRef
    .set(gameData)
    .then(() => {
      console.log("Game saved in Cloud!");
    })
    .catch((error) => {
      console.log(error);
    });
};

export const saveSupportShopInCloud = async (uid: string, shopData: any) => {
  const userRef = db.collection("users").doc(uid);

  console.log("Saving shop in Cloud:", shopData);
  await userRef
    .update(shopData)
    .then(() => {
      console.log("Shop saved in Cloud!");
    })
    .catch((error) => {
      console.log(error);
    });
};

export const loadGameFromCloud = async (uid: string) => {
  const userRef = db.collection("users").doc(uid);
  try {
    const game = await userRef.get();
    if (!game.exists) {
      console.log("No such Save!");
    } else {
      if (game.data()) {
        const gameData = {
          ...game.data(),
          unlockedAchievementIds: new Set<number>(
            game.data()?.unlockedAchievementIds
          ),
          producers: game.data()?.producers.map((producer: any) => ({
            ...producer,
            value: new Decimal(producer.value),
          })),
          molecule: {
            ...game.data()?.molecule,
            value: new Decimal(game.data()?.molecule.value),
          },
          last10MoleculeCreations: game
            .data()
            ?.last10MoleculeCreations.map((creation: any) => ({
              ...creation,
              molecules: new Decimal(creation.molecules),
            })),
        };

        if (gameData) {
          return gameData as Game;
        }
      }
    }
  } catch (error) {
    console.log("Error loading game:", error);
    // Implement retry logic here, such as retrying after a certain interval
  }
};

export const deleteGameInCloud = async (uid: string) => {
  const userRef = db.collection("users").doc(uid);
  await userRef
    .delete()
    .then(() => {
      console.log("Save deleted!");
    })
    .catch((error) => {
      console.log(error);
    });
};

export const validateToken = async (token: string) => {};
